import React, { useEffect, useState } from 'react';
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from '../../../../_metronic/_partials/controls';
import Table, {
	dateFormatter,
	buttonsStyle	
} from '../../../components/tables/table';
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog';
import { getMuscleGroups, deleteMuscleGroup, changeStatusMuscleGroup } from '../../../../api/muscleGroup';
import { Button, Tooltip } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { alertError, alertSuccess } from '../../../../utils/logger';
import { useHistory } from 'react-router-dom';
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import { shallowEqual, useSelector } from 'react-redux';
import { getNonEmpty } from '../../../../utils/helpers';
import { SERVER_URL } from '../../../../api';
import PreviewDialog from '../../../components/dialogs/PreviewDialog';

function getData(muscleGroups) {
	let data = [];
	for (let i = 0; i < muscleGroups.length; ++i) {
		const elem = {};
		elem.img = muscleGroups[i].iconURL;
		elem.name = getNonEmpty(muscleGroups[i].fullName);
		elem.createdAt = muscleGroups[i].createdAt;
		elem.id = muscleGroups[i]._id;
		elem.active = muscleGroups[i].active;
		data = data.concat(elem);
	}
	return data;
}

export default function MuscleGroupsPage() {
	const [data, setData] = useState([]);
	const [muscleGroupId, setMuscleGroupId] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [refresh, setRefresh] = useState(false);
	const [openPreviewDialog, setOpenPreviewDialog] = useState(false)
	const [previewImage, setPreviewImage] = useState(null)
	const history = useHistory();
	const user = useSelector((store) => store.authentication?.user, shallowEqual)

	function imageFormatter(cell) {
		return (cell && cell !== '') ? (
		  <img 
			src={SERVER_URL + '/' + cell} 
			alt="muscle-group" 
			style={{ width: '50px', height: '50px' }} 
			onClick={() => {
			  setPreviewImage(cell)
			  setOpenPreviewDialog(true)
			}}/>
		) : (
		  <div/>
		);
	  }

	function buttonFormatter(cell) {
		const elem = data.find(item => item.id === cell)
		return (
			<>
				<Tooltip title='Edit'>
					<Button
						style={buttonsStyle}
						size='small'
						onClick={() => history.push('/edit-muscle-group/' + cell)}>
						<EditIcon />
					</Button>
				</Tooltip>
				{user?.role.includes('admin') && <>
					<Tooltip title={elem?.active ? "Disable" : "Enable"}>
						<Button
							style={buttonsStyle} size="small"
							onClick={() => {
								setMuscleGroupId(elem)
								setOpenConfirmDialog(1)
							}}>
							{elem?.active ? <ToggleOffIcon/> : <ToggleOnIcon style={{ color: 'red' }} />}
						</Button>
					</Tooltip>
					<Tooltip title='Delete'>
						<Button
							style={buttonsStyle}
							size='small'
							onClick={() => {
								setMuscleGroupId(cell);
								setOpenConfirmDialog(2);
							}}>
							<DeleteIcon />
						</Button>
					</Tooltip>
				</>}
			</>
		);
	}

	const columns = [
		{ dataField: 'img', text: 'Icon', sort: false, formatter: imageFormatter },
		{ dataField: 'name', text: 'Full name', sort: true },
		{
			dataField: 'createdAt',
			text: 'Created at',
			formatter: dateFormatter,
			sort: true,
		},
		{ dataField: 'id', text: '', formatter: buttonFormatter },
	];

	useEffect(() => {
		getMuscleGroups()
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data));
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({ error: error, customMessage: 'Could not get muscle groups.' });
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title='Muscle groups list'>
					<CardHeaderToolbar>
						<button
							type='button'
							className='btn btn-primary'
							onClick={() => history.push('/edit-muscle-group')}>
							Add new
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table data={data} columns={columns} />
					<PreviewDialog
						title={'Preview icon'}
						open={openPreviewDialog}
						setOpen={setOpenPreviewDialog}
						src={previewImage ? `${SERVER_URL}/${previewImage}` : null}
					/>
					<ConfirmDialog
						title={`Are you sure you want to ${muscleGroupId?.active ? 'disable' : 'enable'} this muscle group?`}
						open={openConfirmDialog === 1}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							changeStatusMuscleGroup(muscleGroupId.id, !muscleGroupId?.active)
								.then((res) => {
									if (res.status === 200) {
										alertSuccess({ title: `${muscleGroupId?.active ? 'Disabled!' : 'Enabled!'}`, customMessage: `Muscle group ${muscleGroupId?.active ? 'disabled' : 'enabled'} successfully` })
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({ error: error, customMessage: `Could not ${muscleGroupId?.active ? 'disable' : 'enable'} muscle group.` })
								});
						}}
					/>
					<ConfirmDialog
						title={'Are you sure you want to remove this muscle group?'}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteMuscleGroup(muscleGroupId)
								.then((res) => {
									if (res.status === 204 || res.status === 200) {
										alertSuccess({
											title: 'Deleted!',
											customMessage: 'Muscle group removed successfully.',
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: 'Could not remove muscle group.',
									});
								});
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
